export default __webpack_public_path__ + "static/media/no-result.a11e49f8.SVG";